import {useCallback, useEffect, useState} from "react";
import {useSnackbarContext} from "../../common/Snackbar";
import * as RealTimeApi from "../../../api/RealTimeApi";

const realTimeApiErrorMessage = "RealTime API not available";

export default function UsePipeReadBackData({hub, pipe}) {
    const [data, setData] = useState(undefined);

    const {handleMessageUpdate} = useSnackbarContext();

    function handleApiError(error) {
        handleMessageUpdate(`${error.message} [${error.code}]`);
    }

    const handleErrorCallback = useCallback(handleApiError, []);

    useEffect(() => {
        function handleDataChanged(pipes) {
            setData(pipes);
        }

        function handleHubRealTimeEvent(event) {
            if (event.type === "telemetry.created") {
                const message = event.payload;
                const pipeId = message["pipe_id"];

                if (pipeId === pipe.id) handleDataChanged(message.payload);
            }
        }

        try {
            RealTimeApi.hubSubscribe(hub.id, handleHubRealTimeEvent);
        } catch (e) {
            handleErrorCallback({message: realTimeApiErrorMessage});
        }

        return () => {
            try {
                RealTimeApi.hubUnsubscribe(hub.id, handleHubRealTimeEvent);
            } catch (e) {
                handleErrorCallback({message: realTimeApiErrorMessage});
            }
        };
    }, [hub.id, pipe.id, handleErrorCallback]);

    return data;
}